import {ORIENTATION, SIZE} from '@/utils/constants/globalStyle'
import {Radio} from 'pepsico-ds'

/**
 * RadioButton component renders a group of radio buttons.
 *
 * @param {object} props - Component props.
 * @param {string[]} props.items - Array of items to be displayed as radio buttons.
 * @param {string} [props.reference='radio-button'] - Reference identifier for the radio button group.
 * @param {string} [props.label=''] - Label for the radio button group.
 * @param {string} [props.helperText=''] - Helper text to be displayed below the radio button group.
 * @param {function} [props.onUpdate] - Callback function to handle the update event.
 * @param {('small'|'large')} [props.size='small'] - Size of the radio buttons (e.g., 'small', 'medium', 'large').
 * @param {boolean} [props.disabled=false] - Flag to disable the radio buttons.
 * @param {boolean} [props.isDark=false] - Flag to apply dark theme styling.
 * @param {number|null} [props.selectedItemIndex=null] - Index of the currently selected item.
 * @param {string|null} [props.feedbackType=null] - Type of feedback to be displayed (e.g., 'error', 'warning', 'info').
 * @param {boolean} [props.selected=false] - Flag to indicate if the radio button is selected.
 * @param {string} [props.className] - Additional class names for custom styling.
 * @param {'horizontal'|'vertical'} [props.orientation='horizontal'] - Layout direction for the radio button group.
 * @param {string} [props.id=''] - Optional additional id to apply to the radio button.
 * @returns {JSX.Element} The rendered RadioButton component.
 */
const RadioButton = ({
  items,
  reference = 'radio-button',
  label = '',
  helperText = '',
  onUpdate,
  size = SIZE.SMALL,
  disabled = false,
  isDark = false,
  selectedItemIndex = null,
  feedbackType = null,
  selected,
  className,
  orientation = ORIENTATION.HORIZONTAL,
  id,
}) => {
  return (
    <Radio
      items={items}
      reference={reference}
      label={label}
      helperText={helperText}
      onUpdate={onUpdate}
      size={size}
      disabled={disabled}
      isDark={isDark}
      selectedItemIndex={selectedItemIndex}
      feedbackType={feedbackType}
      selected={selected}
      className={className}
      orientation={orientation}
      id={id}
    />
  )
}

export default RadioButton
